import { useHealthInsuranceContext } from 'contexts/HealthInsuranceContext';
import { FileDownloadBox, Form, formModelGet } from '@portal/ui-library';
import { useApplicationHelpers } from 'hooks/useApplicationHelpers';
import { partnerField } from 'models';
import { PersonRoleEnum } from 'models/extension-generated';
import { useTranslation } from 'react-i18next';
import { IconButton, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export const AccompaniedDocumentsDownload = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation('summaryPage');
  const { state } = useHealthInsuranceContext();
  const { getSinglePartnerByRole } = useApplicationHelpers(state.model);

  const { id: holderId = '' } = getSinglePartnerByRole(PersonRoleEnum.POLICY_HOLDER);
  const hasDownloadedContractInformationDocumentPath = partnerField(
    holderId,
    'applicationInformation.hasDownloadedContractInformationDocument'
  );
  const hasDownloadedContractInformationDocument = formModelGet(
    state.model,
    hasDownloadedContractInformationDocumentPath
  );
  const { hasError, message } = Form.hooks.useFormComponent(
    hasDownloadedContractInformationDocumentPath
  );

  return (
    <>
      <FileDownloadBox
        id="downloadDocument"
        isDone={hasDownloadedContractInformationDocument}
        label={t('downloadDocument')}
        ariaDescribedBy="errorMessage health-info-text "
        onClick={onClick}
      />
      {hasError && (
        <div>
          <div
            id="errorMessage"
            className="block w-full mt-[5px] pl-[16px] text-error-700 text-[12px] text-danger-60"
          >
            {message || 'hasError'}
          </div>
        </div>
      )}
      <div
        aria-roledescription="information"
        aria-label={'Hinweis'}
        className="my-m p-[8px] bg-surface-60 gap-s flex items-center rounded-md"
      >
        <IconButton size="small" className="text-highlight-80" aria-describedby="health-info-text">
          <InfoIcon />
        </IconButton>
        <span id="health-info-text">
          <Typography variant="bodySMRegular" className="inline">
            <strong>Hinweis: </strong>
            Folgende Dokumente mit für Sie wichtigen Informationen liegen Ihnen in
            nicht-barrierefreier Form vor und werden als separate Datei heruntergeladen:
          </Typography>
          <ul>
            <Typography component="li" variant="bodySMRegular">
              die Kundeninformation einschließlich Widerrufsbelehrung,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die Tarifinformationen,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die allgemeinen Versicherungsbedingungen,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die Mitteilung nach § 19 Abs. 5 VVG über die Folgen einer Verletzung der gesetzlichen
              Anzeigepflicht,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die Information über das außergerichtliche Streitbeilegungsverfahren,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die Einwilligungs- und Schweigepflichtentbindungserklärung,
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              das Informationsblatt Krankenversicherung der Bundesanstalt für
              Finanzdienstleistungsaufsicht und
            </Typography>
            <Typography component="li" variant="bodySMRegular">
              die Datenschutzhinweise bei Beantragung eines Kranken- oder
              Pflegeversicherungsvertrages inkl. Hinweise zur Antragsprüfung (u.a.
              Bonitätsauskunft).
            </Typography>
          </ul>
        </span>
      </div>
    </>
  );
};
